// This file was generated by "make codegen/iam". DO NOT EDIT.

import { GENERATE_REGISTRATION_TOKEN as ACTION_MONDOO_AGENTS_AGENTMANAGER_GENERATEREGISTRATIONTOKEN } from "~/lib/iam/actions/mondoo/agents/AgentManager/GenerateRegistrationToken/action";
import { LIST_REGISTRATION_TOKENS as ACTION_MONDOO_AGENTS_AGENTMANAGER_LISTREGISTRATIONTOKENS } from "~/lib/iam/actions/mondoo/agents/AgentManager/ListRegistrationTokens/action";
import { VERIFY_REGISTRATION_TOKEN as ACTION_MONDOO_AGENTS_AGENTMANAGER_VERIFYREGISTRATIONTOKEN } from "~/lib/iam/actions/mondoo/agents/AgentManager/VerifyRegistrationToken/action";

export const allowedActions = [
  ACTION_MONDOO_AGENTS_AGENTMANAGER_GENERATEREGISTRATIONTOKEN,
  ACTION_MONDOO_AGENTS_AGENTMANAGER_LISTREGISTRATIONTOKENS,
  ACTION_MONDOO_AGENTS_AGENTMANAGER_VERIFYREGISTRATIONTOKEN,
] as const;
